import type { ProfileType } from 'types/user';
import { currentUser, isLoggedIn } from './authentication';

const currentProfile = ({
  index,
  changeUserToPlayer = true,
}: {
  index: number;
  changeUserToPlayer?: boolean;
}): ProfileType | null => {
  if (!isLoggedIn()) return null;

  let profile = currentUser().available_profiles?.[index];
  if (changeUserToPlayer && profile?.type === 'user' && currentUser().fit_player_profile_id)
    profile = {
      type: 'fit_player_profile',
      id: currentUser().fit_player_profile_id,
    };
  return profile;
};

export const getPlayerLink = (id: number) => (isCurrentPlayerProfile(id) ? '/profilo' : `/giocatore/${id}`);

export const isCurrentPlayerProfile = (id: number) => isLoggedIn() && currentUser().fit_player_profile_id === id;

export default currentProfile;
